import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { HomePageRevision } from "@/types";
import { fetchHomePageRevision } from "./thunk";

export interface HomePageRevisionState {
  homePageRevision: Partial<HomePageRevision>;
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: HomePageRevisionState = {
  homePageRevision: {},
  error: null,
  status: "idle"
};

export const homePageRevisionSlice = createSlice({
  name: "homePageRevision",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[homePageRevisionSlice.name]
        };
      })
      .addCase(fetchHomePageRevision.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchHomePageRevision.fulfilled, (state, action) => {
        state.status = "idle";
        state.homePageRevision = action.payload;
      })
      .addCase(fetchHomePageRevision.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
